import { GUIDED_SAMPLE_TEXT, GUIDED_SAMPLE_TITLE } from "./guided-sample";
import { escapeHtml } from "./html";
import type { ParserMode } from "./types";

export interface ImportTextSample {
  id: string;
  title: string;
  description: string;
  parserMode: ParserMode;
  text: string;
}

export const IMPORT_TEXT_SAMPLES: readonly ImportTextSample[] = [
  {
    id: "guided-tempest",
    title: GUIDED_SAMPLE_TITLE,
    description: "@speaker tags · 2 roles",
    parserMode: "tag",
    text: GUIDED_SAMPLE_TEXT,
  },
  {
    id: "tempest-left",
    title: "The Tempest — Act I, Scene II",
    description: "Speaker on left · 2 roles",
    parserMode: "left",
    text: `The Tempest — Act I, Scene II
#Page1
PROSPERO: Be collected: no more amazement. Tell your piteous heart there's no harm done.
MIRANDA: O, woe the day!
PROSPERO: No harm. I have done nothing but in care of thee, my dear one, thee, my daughter.
MIRANDA: If by your art, my dearest father, you have put the wild waters in this roar, allay them.
(Prospero lays down his mantle.)
PROSPERO: 'Tis time I should inform thee farther. Lend thy hand, and pluck my magic garment from me.
MIRANDA: Alack, what trouble was I then to you!
#Page2
MIRANDA: Wherefore did they not that hour destroy us?
PROSPERO: Dear, they durst not, so dear the love my people bore me.
MIRANDA: How came we ashore?
PROSPERO: By Providence divine. Some food we had and some fresh water that Gonzalo did give us.`,
  },
  {
    id: "as-you-like-it-top",
    title: "As You Like It — Act II, Scene VII",
    description: "Speaker above · 4 roles",
    parserMode: "top",
    text: `As You Like It — Act II, Scene VII

DUKE SENIOR
Welcome. Set down your venerable burden, and let him feed.

ORLANDO
I thank you most for him.

ADAM
So had you need: I scarce can speak to thank you for myself.

DUKE SENIOR
If that you were the good Sir Rowland's son, be truly welcome hither.

JAQUES
All the world's a stage, and all the men and women merely players.

JAQUES
They have their exits and their entrances; and one man in his time plays many parts.

ORLANDO
I am the son of old Sir Rowland, and youngest son was I his house.`,
  },
];

export function getImportTextSample(id: string): ImportTextSample | undefined {
  return IMPORT_TEXT_SAMPLES.find((sample) => sample.id === id);
}

export function renderImportTextSamplePicker(): string {
  return `<section class="import-samples" aria-labelledby="import-samples-heading">
    <div><strong id="import-samples-heading">Or start with a sample</strong><small>Choose one to put its text in the script area below.</small></div>
    <div class="import-samples__options">${IMPORT_TEXT_SAMPLES.map((sample) => `<button class="button button--ghost button--small" type="button" data-load-text-sample="${escapeHtml(sample.id)}"><span>${escapeHtml(sample.title)}</span><small>${escapeHtml(sample.description)}</small></button>`).join("")}</div>
    <p class="import-samples__status" data-import-sample-status role="status" aria-live="polite"></p>
  </section>`;
}
